import { ApolloProvider } from '@apollo/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { memoize } from '@infl-ts/util-function';
import { PageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { DeviceTypeProvider } from '@infl-ts/util-use-device-type';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getCache = memoize(function () {
  var cache = createCache({
    key: 'css',
    prepend: true
  });
  cache.compat = true;
  return cache;
});
export var SetupApp = function SetupApp(_ref) {
  var deviceType = _ref.deviceType,
      apolloClient = _ref.apolloClient,
      Router = _ref.Router,
      onRenderComplete = _ref.onRenderComplete,
      _ref$disablePageEvent = _ref.disablePageEventsTracker,
      disablePageEventsTracker = _ref$disablePageEvent === void 0 ? false : _ref$disablePageEvent,
      children = _ref.children;

  var _useState = useState(function () {
    return new QueryClient();
  }),
      queryClient = _useState[0];

  return /*#__PURE__*/_jsxs(QueryClientProvider, {
    client: queryClient,
    "data-element": "QueryClientProvider",
    "data-component": "SetupApp",
    "data-source-file": "setup-app.tsx",
    children: [onRenderComplete ? /*#__PURE__*/_jsx("div", {
      ref: function ref() {
        return void onRenderComplete();
      }
    }) : null, /*#__PURE__*/_jsx(ApolloProvider, {
      client: apolloClient,
      "data-element": "ApolloProvider",
      "data-component": "SetupApp",
      "data-source-file": "setup-app.tsx",
      children: /*#__PURE__*/_jsx(CacheProvider, {
        value: getCache(),
        "data-element": "CacheProvider",
        "data-component": "SetupApp",
        "data-source-file": "setup-app.tsx",
        children: /*#__PURE__*/_jsx(Router, {
          "data-element": "Router",
          "data-component": "SetupApp",
          "data-source-file": "setup-app.tsx",
          children: /*#__PURE__*/_jsx(DeviceTypeProvider, {
            deviceType: deviceType,
            "data-element": "DeviceTypeProvider",
            "data-component": "SetupApp",
            "data-source-file": "setup-app.tsx",
            children: disablePageEventsTracker ? children : /*#__PURE__*/_jsx(PageEventsTracker, {
              children: children
            })
          })
        })
      })
    })]
  });
};